export default "__VITE_ASSET__BXrWKDnf__"